import type { RequestHandler } from 'msw';
import { setupWorker } from 'msw/browser';

const isMswEnabled = () => {
  const flag = import.meta.env.VITE_ENABLE_MSW;

  if (flag === undefined) {
    return false;
  }

  return /^(true|1)$/i.test(String(flag).trim());
};

/**
 * Dynamically imports all MSW mock handlers from entity modules.
 */
const getMswHandlers = (): RequestHandler[] => {
  // import.meta.glob を使用してすべてのentity配下のapi.msw.tsを動的にインポート
  const mswModules = import.meta.glob<{ getDnRAPIMock: () => RequestHandler[] }>(
    '@/entities/**/api.msw.ts',
    { eager: true },
  );

  // 各モジュールから getDnRAPIMock() を実行してハンドラーを収集
  const handlers = Object.values(mswModules).flatMap((module) => module.getDnRAPIMock?.() ?? []);

  return handlers;
};

/**
 * MSW worker instance with all API handlers.
 */
const worker = setupWorker(...getMswHandlers());

/**
 * Starts the MSW worker for local development.
 */
const startWorker = async () => {
  await worker.start({
    serviceWorker: {
      url: '/mockServiceWorker.js',
    },
    onUnhandledRequest: 'bypass',
  });

  return worker;
};

/**
 * Conditionally bootstraps the browser MSW worker for local development.
 */
export const setupMsw = async () => {
  if (!import.meta.env.DEV) {
    return false;
  }

  if (!isMswEnabled()) {
    return false;
  }

  await startWorker();

  return true;
};
